import { render, staticRenderFns } from "./MoneyText.vue?vue&type=template&id=7fe72e86"
import script from "./MoneyText.vue?vue&type=script&lang=js"
export * from "./MoneyText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe72e86')) {
      api.createRecord('7fe72e86', component.options)
    } else {
      api.reload('7fe72e86', component.options)
    }
    module.hot.accept("./MoneyText.vue?vue&type=template&id=7fe72e86", function () {
      api.rerender('7fe72e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/MoneyText.vue"
export default component.exports